import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";

import API from "../../api/index";
import { Row, Card, Button, Input, Form, FormGroup, CardTitle, Label, Collapse, CardBody, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import moment from "jalali-moment";
import { Colxx } from "Components/CustomBootstrap";
import "react-circular-progressbar/dist/styles.css";
import "react-tabs/style/react-tabs.css";
import './inventory-status.css';
import StateButton from "Components/StateButton";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CustomSelectInput from "Components/CustomSelectInput";
var classNames = require("classnames");
import { RangeDatePicker } from "jalali-react-datepicker";
import { NotificationManager } from "Components/ReactNotifications";
import { validJournalInteger } from '../../util/journal-input';

class WarehousingInventory extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchStockStatus: "stock",
			SearchPhrase: "",
			showDetails: false,
			isRefreshing: false,
			isLoading: true,
			inventoryList: [],
			modalCreateCheckPointTransactionOpen: false,
			newCheckPointTransaction: {
				count: "",
				description: "",
				productId: -1,
			},
			newCheckPointModifiedProductId: -1,
			newCheckPointTransactionReset: null,
			newCheckPointTransactionButtonClicked: false,
		};
		this.modalCreateCheckPointTransactionToggle = this.modalCreateCheckPointTransactionToggle.bind(this);
		this.validatenewCheckPointTransactionFilter = this.validatenewCheckPointTransactionFilter.bind(this);
		this.validateTransactionCreation = this.validateTransactionCreation.bind(this);
		this.handleCreateCheckPoint = this.handleCreateCheckPoint.bind(this);
		this.handleCreateCheckPointTransactionButtonClick = this.handleCreateCheckPointTransactionButtonClick.bind(this);
		this.handleTransactionCreateReset = this.handleTransactionCreateReset.bind(this);

		this.componentDidMount = this.componentDidMount.bind(this);
		this.loadData = this.loadData.bind(this);
	}
	handleCreateCheckPoint = (productId) => {
		this.setState({
			newCheckPointTransaction: {
				productId,
				count: 0,
				description: "",
			},
			modalCreateCheckPointTransactionOpen: true,
		});
	};
	handleTransactionCreateReset() {
		// reset newTransaction to the initial state
		const newTransactionResetTemp = this.state.newCheckPointTransactionReset;
		this.setState({ newCheckPointTransaction: { ...newTransactionResetTemp } });
	}
	handleFocus = (event) => event.target.select();
	modalCreateCheckPointTransactionToggle() {
		this.setState({
			modalCreateCheckPointTransactionOpen: !this.state.modalCreateCheckPointTransactionOpen,
		});
	}
	handleCreateCheckPointTransactionButtonClick() {
		return new Promise((success, fail, $this) => {
			this.setState({ newCheckPointTransactionButtonClicked: true });
			API.post("warehousing/inventory/add-checkpoint", this.state.newCheckPointTransaction)
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت تراکنش");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت تراکنش", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
						}
						this.setState({
							newCheckPointTransactionButtonClicked: false,
						});
					} else {
						success("تراکنش ثبت شد");
						setTimeout(() => {
							this.setState({ newCheckPointTransactionButtonClicked: false, modalCreateCheckPointTransactionOpen: false, newCheckPointModifiedProductId: this.state.newCheckPointTransaction.productId });
							this.handleTransactionCreateReset();
							this.loadData();
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت تراکنش");
					this.setState({
						newCheckPointTransactionButtonClicked: false,
					});
				});
		});
	}
	validateTransactionCreation() {
		const filters = {
			"transaction-count": this.state.newCheckPointTransaction.count,
		};

		for (const [key, value] of Object.entries(filters)) {
			if (!this.validatenewCheckPointTransactionFilter(key, value)) {
				return false;
			}
		}

		return true;
	}
	validatenewCheckPointTransactionFilter(filter, value) {
		if (value === undefined) {
			return false;
		}
		switch (filter) {
			case "transaction-count":
				if (validJournalInteger(value, 0)) {
					return true;
				}
				break;
			case "transaction-productid": {
				if (value > 0) {
					return true;
				}
				break;
			}
			case "transaction-description":
				if (value.length > 2) {
					return true;
				}
				break;
		}
		return false;
	}
	componentDidMount() {
		const newCheckPointTransactionReset = { ...this.state.newCheckPointTransaction };
		this.setState(
			{
				newCheckPointTransactionReset: { ...newCheckPointTransactionReset },
			},
			() => {
				this.loadData();
			}
		);
	}

	loadData() {
		this.setState({ isRefreshing: true });
		API.post("warehousing/inventory/list", this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

				this.setState(
					{
						inventoryList: data.inventoryList,
						products: data.products,
						settings: data.settings,
						isLoading: false,
						isRefreshing: false,
					},
					function () {}
				);
			})
			.catch((error) => {});
	}
	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				{/* <Row className={"invoice"}> */}
				<Row className={"invoice"}>
					<Colxx xl="12">
						<Card>
							<CardBody>
								<CardTitle className={"print-hide"}>
									<div
										className={"simple-icon-list headingicon"}
										onClick={() => {
											this.setState({ showDetails: !this.state.showDetails });
										}}
										style={{ color: this.state.showDetails ? "#4fcdc4" : "#556270" }}
									/>
									موجودی انبار{" "}
									<Button
										className={"default mb-1"}
										outline
										color={"info"}
										style={{ float: "left", border: "unset", width: "40px", borderRadius: 50, padding: "10px" }}
										onClick={() => {
											this.setState({ isRefreshing: true });
											this.loadData();
										}}
									>
										<div className={" simple-icon-reload tableheadingicon"} />
									</Button>
									<div style={{ width: 400, float: "left", display: "inline-block", marginLeft: "10px", borderRadius: 50 }}>
										<Input
											type="select"
											onChange={(e) => this.setState({ searchStockStatus: e.target.value })}
											value={this.state.searchStockStatus}
											style={{
												width: "calc(50% - 5px)",
												float: "right",
												borderRadius: "20px",
											}}
										>
											<option value="stock">موجودی</option>
											<option value="instock">موجود</option>
											<option value="outofstock">ناموجود</option>
											<option value="lowstock">موجودی کم</option>
										</Input>

										<Input
											autoComplete="off"
											type="text"
											name="SearchPhrase"
											id="SearchPhrase"
											color="info"
											placeholder=""
											value={this.state.SearchPhrase}
											onChange={(e) => {
												this.setState({ SearchPhrase: e.target.value });
											}}
											style={{ width: "calc(50% - 5px)", float: "left", borderRadius: "50px", padding: "9px", lineHeight: "29px", paddingBottom: "5px", paddingTop: "7px", paddingLeft: "35px", paddingRight: "19px" }}
										/>
										<Button
											style={{
												position: "absolute",
												top: 22,
												marginRight: "365px",
												marginTop: "11px",
												fontSize: 20,
												padding: "5px",
												color: "lightgray",
												backgroundColor: "transparent",
												border: "unset",
												display: this.state.SearchPhrase != "" ? "block" : "none",
											}}
											onClick={(e) => {
												this.setState({ SearchPhrase: "" });
											}}
										>
											<i className="simple-icon-close"></i>
										</Button>
									</div>
									<Modal size="lg" isOpen={this.state.modalCreateCheckPointTransactionOpen} toggle={this.modalCreateCheckPointTransactionToggle}>
										<ModalHeader toggle={this.modalCreateCheckPointTransactionToggle}>
											{" "}
											ثبت موجودی:<b> {this.state.newCheckPointTransaction.productId != -1 ? this.state.products.find((product) => product.id === this.state.newCheckPointTransaction.productId).name : ""}</b>
										</ModalHeader>
										<ModalBody>
											<Row>
												<Colxx sm={4}>
													<FormGroup className={"filter " + (this.validatenewCheckPointTransactionFilter("transaction-count", this.state.newCheckPointTransaction.count) ? "filter-active" : "")}>
														<Label for="newCheckPointTransactionCount" style={{ width: "100%" }}>
															موجودی فعلی *
														</Label>
														<NumberFormat
															value={this.state.newCheckPointTransaction.count}
															onClick={this.handleFocus}
															onValueChange={(values) => {
																var tmpObj = { ...this.state.newCheckPointTransaction };
																tmpObj.count = values.value;
																this.setState({ newCheckPointTransaction: tmpObj });
															}}
															style={{ width: "60%", height: "40px", border: "1px solid #d7d7d7", display: "inline-block", float: "right" }}
															thousandSeparator={true}
														/>
														<span
															style={{
																border: "1px solid ",
																borderColor: "lightgray",
																borderRadius: "5px",
																background: "lightgray",
																marginRight: 10,
																display: "inline-block",
																width: "30%",
																height: "40px",
																lineHeight: "30px",
																textAlign: "center",
																paddingTop: "5px",
																paddingLeft: "10px",
																paddingRight: "10px",
																textAlign: "center",
																flaot: "left",
																color: "gray",
															}}
														>
															قلم
														</span>
													</FormGroup>
												</Colxx>

												<Colxx sm={8}>
													<FormGroup className={"filter " + (this.validatenewCheckPointTransactionFilter("transaction-description", this.state.newCheckPointTransaction.description) ? "filter-active" : "")}>
														<Label for="newCheckPointTransactionDescription">توضیحات</Label>

														<Input
															type="text"
															name="newCheckPointTransactionDescription"
															id="newCheckPointTransactionDescription"
															onClick={this.handleFocus}
															placeholder="توضیحات (اختیاری)"
															value={this.state.newCheckPointTransaction.description}
															onChange={(e) => {
																var tmpObj = { ...this.state.newCheckPointTransaction };
																tmpObj.description = e.target.value;
																this.setState({ newCheckPointTransaction: tmpObj });
															}}
														/>
													</FormGroup>
												</Colxx>
											</Row>
										</ModalBody>
										<ModalFooter>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
													marginTop: "-14px",
												}}
												className={"default"}
												onClick={this.handleTransactionCreateReset}
											>
												ریست
											</Button>
											<StateButton
												disabled={!this.validateTransactionCreation() || this.state.newCheckPointTransactionButtonClicked}
												id="newBatchSaveButton"
												color="primary"
												className="mb-3 default"
												onClick={() => this.handleCreateCheckPointTransactionButtonClick()}
											>
												ثبت
											</StateButton>
										</ModalFooter>
									</Modal>
								</CardTitle>
								<div className="table-responsive">
									<table className="table table-hover">
										<thead>
											<tr>
												{this.state.showDetails && <th style={{ width: "100px" }}>#</th>}
												{this.state.showDetails && <th style={{ width: "100px" }}>کد</th>}
												<th>نام محصول</th>
												<th style={{ "text-align": "center", width: "120px" }} className={"print-hide"}>وضعیت</th>
												<th style={{ "text-align": "center", width: "120px" }}>موجودی</th>
												<th style={{ "text-align": "center", width: "120px" }} className={"print-hide"}>حد سفارش</th>
												{this.state.showDetails && <th style={{ "text-align": "center", width: "120px" }} className={"print-hide"}>رزرو</th>}
												{this.state.showDetails && <th style={{ "text-align": "center", width: "120px" }} className={"print-hide"}>انبارگردانی</th>}
											</tr>
										</thead>

										{!this.state.isRefreshing ? (
											<Fragment>
												{this.state.inventoryList
													.filter((product) => !this.state.searchStockStatus || (product.stockStatus + "").includes(this.state.searchStockStatus))
													.filter((product) => {
														const searchPhrase = this.state.SearchPhrase.trim();
														return searchPhrase === "" || product.name.includes(searchPhrase) || (product.stockStatusFa + "").includes(searchPhrase) || (product.stockStatus + "").includes(searchPhrase);
													})
													.map((row, index) => (
														<TabAllTableRows
															key={row.id}
															index={index}
															data={row}
															showDetails={this.state.showDetails}
															newCheckPointTransactionButtonClicked={this.state.newCheckPointTransactionButtonClicked}
															modifiedProductId={this.state.newCheckPointModifiedProductId}
															onCreateCheckPoint={this.handleCreateCheckPoint}
														/>
													))}
											</Fragment>
										) : (
											<tbody>
												<tr>
													<td colSpan={8} style={{ padding: "20px" }}>
														<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
													</td>
												</tr>
											</tbody>
										)}
									</table>
								</div>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}
class TabAllTableRows extends Component {
	render() {
		const {
			data: { id, name, stockLevel, stockThreshold, stockReserved, stockStatus, stockStatusFa },
			index,
			showDetails,
			newCheckPointTransactionButtonClicked,
			onCreateCheckPoint,
			modifiedProductId,
		} = this.props;

		return (
			<tbody>
				<tr className={"order-spacer"}></tr>

				<tr
					className={classNames({
						"order-item": true,
						"highlight-row": modifiedProductId == id,
					})}
				>
					{showDetails && <td className={"text-muted"}>{index + 1}</td>}
					{showDetails && <td className={"text-muted"}>{id}</td>}
					<td>{name}</td>
					<td style={{ textAlign: "center", verticalAlign: "middle" }} className={"print-hide"}>
						<span className={`inventory-stock-status inventory-stock-status--${stockStatus}`}><span>{stockStatusFa}</span></span>
					</td>
					<td style={{ "text-align": "center" }}>{stockLevel}</td>
					<td className={"text-muted print-hide"} style={{ "text-align": "center" }}>
						{stockThreshold}
					</td>
					{showDetails && (
						<td className={"text-muted print-hide"} style={{ "text-align": "center" }}>
							{stockReserved}
						</td>
					)}
					{showDetails && (
						<td className={"text-muted print-hide"} style={{ "text-align": "center" }}>
							<Button color="primary" outline style={{ float: "left", background: "white" }} className={"default btn-in-row"} disabled={newCheckPointTransactionButtonClicked} onClick={() => onCreateCheckPoint(id)}>
								<i className="iconsminds-add icon-size-20" style={{ fontWeight: "bold" }}></i>&nbsp;ثبت موجودی
							</Button>
						</td>
					)}
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return {};
};

const mapDispatchToProps = { logoutUser };

export default injectIntl(connect(mapStateToProps, { logoutUser })(WarehousingInventory));
